export default __webpack_public_path__ + "static/media/filter_icon_entrance.75c86c58.svg";